import { Link, scroller } from "react-scroll";
import { useState, useRef, useEffect } from "react";
import monsterrWorldBg from "./img/monsterra-world-bg.webp";
import ambassadorBg from "./img/ambassador-bg.webp";
import partnerShipBg from "./img/partner-ship-bg-webp.png";
import focus from "./img/focus.webp";
import startBg from "./img/start-bg.webp";
import startBtn from "./img/start-btn.webp";
import followPlay from "./img/follow-play.webp";
import followDao from "./img/follow-dao.webp";
import followMarket from "./img/follow-market.webp";
import followGuild from "./img/follow-guild.webp";
import followPortal from "./img/follow-portal.webp";
import followBridge from "./img/follow-bridge.webp";
import followMonstv from "./img/follow-monstv.png";
import followEvent from "./img/follow-events.webp";
import fx from "./img/fx.webp";
import { useOnClickOutside } from "../hooks/useClickOutside";
var Scroll = require("react-scroll");
var Events = Scroll.Events;
function MenuItem({ title, scrollTo, isHead, linkTo }: any) {
  function content() {
    return (
      <div
        className={`hover-container relative h-[29px] w-full ${
          isHead && "pb-[42px]"
        }`}
      >
        <div className="px-[14px] show-on-hover h-full w-full">
          <img className="w-full h-full" src={focus} />
        </div>
        {isHead ? (
          <p className="text-[#ffd862] text-[17px] w-full text-base font-normal cursor-pointer react-button absolute top-0 left-0 text-center text-white-on-hover opacity-0">
            {title}
          </p>
        ) : (
          <p className="text-[#ffd862] text-[14px] w-full text-base font-normal cursor-pointer react-button absolute top-0 left-0 text-center text-white-on-hover">
            {title}
          </p>
        )}
      </div>
    );
  }
  if (scrollTo) {
    return (
      <Link
        to={scrollTo}
        spy={true}
        smooth={true}
        duration={500}
        onSetActive={() => {}}
        className="relative hover-container"
      >
        {content()}
      </Link>
    );
  }
  return (
    <a href={linkTo} className="relative hover-container">
      {content()}
    </a>
  );
}
function MenuBigItem({ title, cap, icon, replaceIcon, disabled, linkTo }: any) {
  return (
    <a href={linkTo}>
      <div
        className={`hover-container relative h-[50px] lg:h-[80px] w-full p-1 cursor-pointer ${
          disabled && "grayscale"
        }`}
      >
        <div className="show-on-hover h-full w-full">
          <img className="w-full h-full" src={fx} />
        </div>
        <div className="flex absolute top-2 left-2 w-full gap-2 items-center">
          <div className="w-8 lg:w-14">
            {replaceIcon || (
              <img
                src={icon}
                className="h-8 lg:h-12 w-8 lg:w-12 object-contain flex-shrink-0"
              />
            )}
          </div>

          <div className="text-left">
            <p className="text-[#ffd862] text-[14px] w-full text-base font-normal cursor-pointer react-button text-left text-white-on-hover mb-1">
              {title}
            </p>
            <span className="hidden lg:block">{cap}</span>
          </div>
        </div>
      </div>
    </a>
  );
}
function MenuLargeItem({ title, cap, icon, replaceIcon, disabled }: any) {
  return (
    <div
      className={`hover-container relative h-[60px] lg:h-[100px] w-full p-1 cursor-pointer ${
        disabled && "grayscale"
      }`}
    >
      <div className="show-on-hover h-full w-full">
        <img className="w-full h-full" src={fx} />
      </div>
      <div className="flex absolute top-2 left-2 w-full gap-2 items-center">
        <img
          src={icon}
          className="h-10 lg:h-20 w-10 lg:w-20 object-contain flex-shrink-0"
        />

        <div className="text-left">
          <p className="text-[#ffd862] text-[18px] lg:text-[24px] w-full text-base font-normal cursor-pointer react-button text-left text-white-on-hover mb-1">
            {title}
          </p>
          <span className="hidden lg:block">{cap}</span>
        </div>
      </div>
    </div>
  );
}
export default function Header(props: any) {
  const [comingsoon, setComingsoon] = useState(false);
  const [optical, setOptical] = useState(0);
  const [elements, setElements] = useState([]);
  const [scrolling, setScrolling] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showInoPopup, setShowInoPopup] = useState(false);
  const refMenuContent = useRef();
  const clickModal = () => {
    setComingsoon(!comingsoon);
  };
  function changeOptical(index: number) {
    if (scrolling) {
      return;
    }
    setOptical(index);
  }
  useEffect(() => {
    if (!window.location.hash) {
      return console.log("hash not found");
    }
    setTimeout(() => {
      let hash = window.location.hash.replace("#", "");
      console.log("doscroll ", hash);
      scroller.scrollTo(hash, { spy: true, smooth: true, duration: 500 });
    }, 1000);
  }, [window.location.hash]);
  useEffect(() => {
    Events.scrollEvent.register("begin", function () {
      setScrolling(true);
    });

    Events.scrollEvent.register("end", function () {
      setScrolling(false);
    });
    return () => {
      Events.scrollEvent.remove("begin");
      Events.scrollEvent.remove("end");
    };
  }, []);
  useOnClickOutside(refMenuContent, () => {
    setTimeout(() => {
      setShowMenu(false);
    }, 200);
  });
  // "monsterra-world" | "ambassador" | "partner-ship" | "get-start"
  function hoverContent(type: string) {
    switch (type) {
      case "monsterra-world":
        return (
          <div className="relative w-full h-full">
            <img src={monsterrWorldBg} className="w-full" />
            <div className="absolute top-[5px] left-0 w-full">
              <MenuItem title="Monsterra World" linkTo={"/#banner"} isHead />
              <MenuItem title="Land" linkTo={"/#land"} />
              <MenuItem title="Gameplay" linkTo="/#playmode" />
              <MenuItem title="MSTR Token" linkTo="/#tokenomic" />
              <MenuItem
                title="Whitepaper"
                linkTo="https://whitepaper.monsterra.io/market-overview/nfts-at-a-glance"
              />
              <MenuItem title="Roadmap" linkTo="/#roadmap" />
            </div>
          </div>
        );
      case "ambassador":
        return (
          <div className="relative w-full h-full">
            <img src={ambassadorBg} className="w-full" />
            <div className="absolute top-[5px] left-0 w-full px-2">
              <MenuItem
                title="Ambassador Program"
                linkTo={"/ambassador/#header"}
                isHead
              />
              <MenuItem title="Who to join" linkTo={"/ambassador/#whotojoin"} />
              <MenuItem title="Benefits" linkTo={"/ambassador/#benefits"} />
              <MenuItem
                title="Pointing System"
                linkTo={"/ambassador/#pointingsystem"}
              />
            </div>
          </div>
        );
      case "partner-ship":
        return (
          <div className="relative w-full h-full">
            <img src={partnerShipBg} className="w-full" />
            <div className="absolute top-[5px] left-0 w-full px-4">
              <MenuItem
                title="Partnership Program"
                scrollTo={"header"}
                isHead
              />
              <MenuItem title="Why partnership" scrollTo="whypartnership" />
              <MenuItem title="Apply partnership" scrollTo="applypartnership" />
              <MenuItem title="Official partners" scrollTo="officialpartners" />
            </div>
          </div>
        );
      case "get-start":
        return (
          <div className="relative w-full h-full">
            <img src={startBg} className="w-full" />
            <div className="absolute top-3 left-0 w-full">
              <div className="flex flex-wrap px-4 lg:px-6  lg:py-4 items-center">
                <div className="w-1/2">
                  <MenuBigItem
                    disabled
                    title="Play game"
                    cap={
                      <p className="text-xs text-[#ad8e73]">Main gameplay</p>
                    }
                    icon={followPlay}
                  />
                </div>
                <div className="w-1/2">
                  <MenuBigItem
                    disabled
                    title="DAO"
                    cap={
                      <p className="text-xs text-[#ad8e73]">
                        Manage your account and
                        <br /> join the governance
                      </p>
                    }
                    icon={followDao}
                  />
                </div>
                <div className="w-1/2">
                  <MenuBigItem
                    linkTo="https://marketplace.monsterra.io/"
                    title="Marketplace"
                    cap={
                      <p className="text-xs text-[#ad8e73]">
                        Buy and sell your
                        <br /> game assets
                      </p>
                    }
                    icon={followMarket}
                  />
                </div>
                <div className="w-1/2">
                  <MenuBigItem
                    disabled
                    title="Guild"
                    replaceIcon={
                      <img
                        src={followGuild}
                        className="h-10 lg:h-14 w-10 lg:w-14 object-contain flex-shrink-0"
                      />
                    }
                    cap={
                      <p className="text-xs text-[#ad8e73]">
                        Make higher benefits with your
                        <br /> friends and fellows
                      </p>
                    }
                    icon={followGuild}
                  />
                </div>
                <div className="w-1/2">
                  <MenuBigItem
                    disabled
                    title="Portal game"
                    cap={
                      <p className="text-xs text-[#ad8e73]">
                        Play minigames with
                        <br />
                        your assets
                      </p>
                    }
                    icon={followPortal}
                  />
                </div>
                <div className="w-1/2">
                  <MenuBigItem
                    disabled
                    title="Bridge"
                    cap={
                      <p className="text-xs text-[#ad8e73]">
                        Transfer your tokens between
                        <br /> supported chains
                      </p>
                    }
                    icon={followBridge}
                  />
                </div>
              </div>
              <div className="flex gap-2 py-2 px-6">
                <div className="w-1/2">
                  <MenuLargeItem
                    disabled
                    title="MonsTV"
                    cap={
                      <p className="text-[16px] text-[#ad8e73] mt-1">
                        Watch and share
                      </p>
                    }
                    icon={followMonstv}
                  />
                </div>
                <div className="w-1/2">
                  <MenuLargeItem
                    disabled
                    title="Events"
                    cap={
                      <p className="text-[16px] text-[#ad8e73] mt-1">
                        Join to earn
                      </p>
                    }
                    icon={followEvent}
                  />
                </div>
              </div>
            </div>
          </div>
        );
    }
  }
  return (
    <div
      className="flex flex-row fixed w-full"
      style={{ top: "-1px", zIndex: 50 }}
    >
      <div
        className="hidden ipadpro:flex flex-row items-center justify-between gap-8 bg-headerbg bg-cover bg-center w-screen  max-w-[1440px]  text-center z-50 hd:h-24 h-20 pb-4 pl-20 pr-14 hd:px-28"
        style={{ backgroundImage: `url(${require("./img/header-bg.webp")})` }}
      >
        <div className="w-[200px]">
          <a href="/">
            <img
              className="cursor-pointer"
              src={require("./img/logo.webp")}
              alt="monsterra logo"
            />
          </a>
        </div>
        <div
          // ref={(ref) => {
          //   if (!ref) {
          //     return;
          //   }
          //   let els: any[] = [];
          //   let index = 0;
          //   ref.childNodes.forEach((i) => {
          //     if (i.localName !== "a") {
          //       return;
          //     }
          //     els.push({
          //       width: i.clientWidth,
          //       pos: i.offsetLeft,
          //     });
          //     index++;
          //     if (elements.length) {
          //       if (els[0].width > elements[0].width) {
          //         setElements(els);
          //       }
          //     } else {
          //       setElements(els);
          //     }
          //   });
          // }}
          className="flex flex-row text-lg font-bold hd:gap-10 gap-4 bg-clip-text items-center justify-center w-full select-none relative"
        >
          <div className="relative hover-container">
            <span className="textGradient cursor-pointer react-button">
              Monsterra World
            </span>
            <div className="absolute top-[-3px] left-[-13px] w-[171px] show-on-hover">
              {hoverContent("monsterra-world")}
            </div>
          </div>

          <div className="relative hover-container">
            <p className="textGradient cursor-pointer react-button">
              Ambassador Program
            </p>
            <div className="absolute top-[-3px] left-[-9px] w-[201px] show-on-hover">
              {hoverContent("ambassador")}
            </div>
          </div>
          <div className="relative hover-container">
            <p className="textGradient cursor-pointer react-button">
              Partnership Program
            </p>
            <div className="absolute top-[-3px] left-[-16px] w-[213px] show-on-hover">
              {hoverContent("partner-ship")}
            </div>
          </div>
          <div className="relative hover-container">
            <p className="textGradient cursor-pointer react-button text-2xl">
              Get START!
            </p>
            <div className="absolute top-[-3px] left-[-16px] w-[213px] show-on-hover">
              <img
                src={startBtn}
                className="w-[197px] top-[-5px] left-[4px] absolute"
              />
            </div>
            <div className="absolute top-[39px] right-[-59px] w-[580px] show-on-hover">
              {hoverContent("get-start")}
            </div>
          </div>
        </div>
      </div>
      <div
        className="flex lg:hidden relative flex-row items-center justify-center w-screen h-[60px] bg-cover bg-center"
        style={{
          backgroundImage: `url(${require("./img/header-mb-bg.webp")})`,
        }}
      >
        <div>
          <a href="/">
            <img
              className="cursor-pointer h-[60px] mt-2 "
              src={require("./img/logo.webp")}
              alt="monsterra logo"
            />
          </a>
        </div>
        <div className="dropdown absolute top-0 left-0 mt-3">
          <img
            className="ml-3 h-10 w-10"
            src={require("./img/menu.png")}
            alt="monsterra menu"
            onClick={() => {
              if (showMenu) return;
              setShowMenu(true);
            }}
          />
          {showMenu && (
            <div
              ref={refMenuContent}
              className="dropdown-content w-screen max-w-[360px] mt-[8px]"
              style={{
                backgroundColor: "rgba(20, 20, 20, 0.85)",
                minWidth: 360,
              }}
            >
              <div className=" flex flex-col items-center">
                <div className="flex flex-col text-lg font-bold gap-2 w-full  select-none p-2">
                  <div>
                    <a href="/">
                      <p className="bg-clip-text text-transparent bg-gradient-to-b from-tab1 via-tab2 to-tab1 cursor-pointer textGradient">
                        Monsterra World
                      </p>
                    </a>
                  </div>
                  <div
                    className="h-[1px] w-full "
                    style={{ backgroundColor: "rgba(65,59,27,1)" }}
                  />
                  <p className="bg-clip-text text-transparent bg-gradient-to-b from-tab1 via-tab2 to-tab1 cursor-pointer textGradient">
                    Ambassador Program
                  </p>
                  <div
                    className="h-[1px] w-full "
                    style={{ backgroundColor: "rgba(65,59,27,1)" }}
                  />
                  <a href="/partnership">
                    <p className="bg-clip-text text-transparent bg-gradient-to-b from-tab1 via-tab2 to-tab1 cursor-pointer textGradient">
                      Partnership Program
                    </p>
                  </a>
                  <div
                    className="h-[1px] w-full "
                    style={{ backgroundColor: "rgba(65,59,27,1)" }}
                  />
                  <p className="bg-clip-text text-transparent bg-gradient-to-b from-tab1 via-tab2 to-tab1 cursor-pointer textGradient">
                    Get START!
                  </p>
                  <div className="">{hoverContent("get-start")}</div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
